// extracted by mini-css-extract-plugin
module.exports = {"chat-content":"ChatWebviewTemplate_chat-content__ZAs8a"};